export const numberFormatter =
    new Intl.NumberFormat();

export const parseCount = (
    value
) => {
    const count = Number.parseInt(
        value ?? '0',
        10
    );

    return Number.isNaN(count)
        ? 0
        : count;
};

export const parseJsonData = (
    value,
    fallback
) => {
    if (!value) {
        return fallback;
    }

    try {
        return JSON.parse(value);
    } catch (error) {
        console.error(
            'Unable to parse festival photo data:',
            error
        );

        return fallback;
    }
};

export const getPhotoData = (
    trigger
) => ({
    id:
        trigger.dataset.photoId
        ?? '',

    url:
        trigger.dataset.photoUrl
        ?? trigger.href,

    caption:
        trigger.dataset.photoCaption
            ?.trim()
        ?? '',

    uploader:
        trigger.dataset.photoUploader
            ?.trim()
        || 'FestFriends member',

    year:
        trigger.dataset.photoYear
            ?.trim()
        ?? '',

    location:
        trigger.dataset.photoLocation
            ?.trim()
        ?? '',

    takenAt:
        trigger.dataset.photoTakenAt
            ?.trim()
        ?? '',

    liked:
        trigger.dataset.photoLiked
        === 'true',

    likeCount:
        parseCount(
            trigger.dataset
                .photoLikeCount
        ),

    selectedReaction:
        trigger.dataset
            .photoSelectedReaction
        || null,

    hasReaction:
        trigger.dataset
            .photoHasReaction
        === 'true',

    reactionCount:
        parseCount(
            trigger.dataset
                .photoReactionCount
        ),

    reactionCounts:
        parseJsonData(
            trigger.dataset
                .photoReactionCounts,
            {
                like: 0,
                fire: 0,
                funny: 0,
                love: 0,
                rock_on: 0,
            }
        ),

    reactionSummary:
        parseJsonData(
            trigger.dataset
                .photoReactionSummary,
            []
        ),

    commentCount:
        parseCount(
            trigger.dataset
                .photoCommentCount
        ),

    commentsUrl:
        trigger.dataset
            .photoCommentsUrl
        ?? '',

    commentStoreUrl:
        trigger.dataset
            .photoCommentStoreUrl
        ?? '',
	mentionMembersUrl:
    trigger.dataset
        .photoMentionMembersUrl
    ?? '',

    reactionUrl:
        trigger.dataset
            .photoReactionUrl
        ?? '',

    reactionsUrl:
        trigger.dataset
            .photoReactionsUrl
        ?? '',

    tagsUrl:
        trigger.dataset
            .photoTagsUrl
        ?? '',

    tagStoreUrl:
        trigger.dataset
            .photoTagStoreUrl
        ?? '',

    canTag:
        trigger.dataset
            .photoCanTag
        === 'true',

    canRemoveOwnTags:
        trigger.dataset
            .photoCanRemoveOwnTags
        === 'true',

    authenticated:
        trigger.dataset
            .photoAuthenticated
        === 'true',

    loginUrl:
        trigger.dataset
            .photoLoginUrl
        ?? '/login',
});

export const setOptionalText = (
    wrapper,
    element,
    value
) => {
    if (!wrapper || !element) {
        return;
    }

    element.textContent = value;

    wrapper.classList.toggle(
        'hidden',
        value === ''
    );
};

export const formatLikeText = (
    count
) => {
    const formattedCount =
        numberFormatter.format(count);

    return `${formattedCount} ${
        count === 1
            ? 'Like'
            : 'Likes'
    }`;
};

export const formatReactionText = (
    count
) => {
    const formattedCount =
        numberFormatter.format(count);

    return `${formattedCount} ${
        count === 1
            ? 'Reaction'
            : 'Reactions'
    }`;
};

export const formatCommentText = (
    count
) => {
    const formattedCount =
        numberFormatter.format(count);

    return `${formattedCount} ${
        count === 1
            ? 'Comment'
            : 'Comments'
    }`;
};